import { FC, useMemo } from 'react';

// Third-party
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import toLower from 'lodash/toLower';
import IconButton from '@mui/material/IconButton';
import Icon from '@mdi/react';
import Box from '@mui/material/Box';

import { useTranslation } from 'react-i18next';
import { BaseBadge, BaseTooltip } from '@mgm/common/components/base';
import { BASE_COLORS } from '@mgm/common/utils';

// Components

// Hooks
import { useResendInvitationAPI } from '../../../../hooks/api';

// Types
import { TMemberStatus } from '../../type';

// Data
import { STATUS_ICONS } from '../../data/team';

const MemberStatus: FC<TMemberStatus> = ({ status, email }) => {
  const { t } = useTranslation('team');
  const { mutate: resendMutate, isLoading } = useResendInvitationAPI();
  const isMemberActive = useMemo(() => toLower(status) === 'active', [status]);

  const resendEmail = () => {
    resendMutate(email);
  };

  return (
    <BaseBadge
      invisible={isMemberActive}
      badgeContent={(
        <BaseTooltip tooltipText={t('resendInvitation')}>
          <Box className="cursor-pointer" onClick={resendEmail} sx={{ pt: 3, pr: 1 }}>
            <FontAwesomeIcon
              color={BASE_COLORS.primary}
              spin={isLoading}
              size="sm"
              icon={['fas', 'rotate']}
            />
          </Box>
        </BaseTooltip>
    )}
    >
      <BaseTooltip tooltipText={t(`${STATUS_ICONS[toLower(status)]?.text}`)}>
        <IconButton className="cursor-initial" disableRipple>
          <Icon
            color={STATUS_ICONS[toLower(status)]?.color}
            size={0.9}
            path={STATUS_ICONS[toLower(status)]?.icon}
          />
        </IconButton>
      </BaseTooltip>
    </BaseBadge>
  );
};

export {
  MemberStatus,
};
